import React from 'react';
import Header from './header';
import Home from './home';

const App = () => {
    return (
        <div>
            <Header />
            <Home />
        </div>
    );
};

export default App;